module.exports = __webpack_public_path__ + "img/09-epg.ca133f71.svg";